export default "__VITE_ASSET__1474b916__"